export interface IAction {
    read: boolean;
    create: boolean;
    edit: boolean;
    delete: boolean;
}

export class PermissionModel {
    name: string;
    prettyName: string;
    action: IAction;
}
